import { useSelector } from 'react-redux';
import { AppState } from '@nxsys/store';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';

/**
 * Labels for a company select on screens shared by both apps: a bureau calls
 * the company an "Employer", an umbrella calls it a "Payment Company".
 */
export const useEmployerFieldLabels = () => {
  const { messages } = useTypedIntl();
  const { isBureau } = useSelector((state: AppState) => state.appStore);

  return isBureau
    ? {
        label: messages['common.employer'],
        placeholder: messages['common.selectEmployer'],
        filterPlaceholder: messages['common.filterByEmployer'],
      }
    : {
        label: messages['common.paymentCompany'],
        placeholder: messages['common.selectPaymentCompany'],
        filterPlaceholder: messages['common.selectPaymentCompany'],
      };
};
